import { ORG_TABS } from "./constants";
export type OrgGuideTab = (typeof ORG_TABS)[keyof typeof ORG_TABS];
export const isOrgGuideTab = (tab: any): tab is OrgGuideTab => {
  return Object.values(ORG_TABS).includes(tab);
};

export type OrgGuideView = "guide" | "full-team360-report";
